import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FlickrService {
  sizesDict = [
    {
      index: 0,
      label: "Square",
      attr:"SquareThumbnailUrl",
      width:75,
      height:75
    },
    {
      index: 1,
      label: "Large Square",
      attr:"LargeSquareThumbnailUrl",
      width:150,
      height:150  
    },
    {
      index: 2,
      label: "Thumbnail",
      atr:"ThumbnailUrl",
      width:100,
      height:75
    },
    {
      index: 3,
      label: "Small",
      attr:"SmallUrl",
      width:240,
      height:180
    },
    {
      index: 4,
      label: "Small 320",
      attr:"Small320Url",
      width:320,
      height:240
    },
    {
      index: 5,
      label: "Medium",
      attr:"MediumUrl",
      width:500,
      height:375
    },
    {
      index: 6,
      label: "Medium 640",
      attr:"Medium640Url",
      width:640,
      height:480
    },    {
      index: 7,
      label: "Medium 800",
      attr:"Medium800Url",
      width:800,
      height:600
    },
    {
      index: 8,
      label: "Large",
      attr:"LargeUrl",
      width:1024,
      height:768
    },
    {
      index: 9,
      label: "Original",
      width:2400,
      height:1800
    }    
  ];

  get sizes() {
    return this.sizesDict;
  }

  constructor() { }
}
